// extracted by mini-css-extract-plugin
export default {"input":"CheckoutDiscountsUiInput_input__fi+20"};